import React, { useEffect, useState } from "react";
import {
  Form,
  message,
  Col,
  Row
} from "antd";
import { useForm } from "antd/lib/form/Form";
import InputIcon from "../components/forms/inputIcon";
import FormButton from "../components/forms/button";
import CustomUploadImage from "../components/forms/uploadFile";
import { useNavigate, useParams } from "react-router-dom";
import { addLesson, editLesson, getData } from "../store/action/lessons";
import CustomTextArea from "../components/forms/textArea";
import { domain } from "../api";
import {Button} from "antd";

export default function AddLesson() {
  const Navigate = useNavigate();
  const [form] = useForm();
  const {id} =  useParams();
  const [data, setData] = useState({})
  const [changeCount, setChangeCount] = useState(0);
  const [removeItem, setRemoveItem] = useState({
    poster : false
  })
  
  
  useEffect(()=>{
    if(id){
      getData(id)
      .then(res => {
        setData(res.data)
        form.setFieldsValue({
          title : res?.data?.title || null,
          description : res?.data?.description || null,


        })
      })
      .catch(res => console.log("failed to retrieved"))
    }

  },[id, changeCount])


  const submitForm = (value) => {
    const file = value?.image?.[0]?.originFileObj;
    delete value.image;
    if (id) {
      value['lesson_id'] = id
      value['removeImage'] = removeItem.poster
    };
    
    const formData = new FormData();
    formData.append('data', JSON.stringify(value));
  
    if (file) {
      formData.append('image', file);
    }
  
    (id ? editLesson(formData) : addLesson(formData))
      .then(res => {
        if (res.status) {
          message.success(res.message);
          form.resetFields(); // Immediate reset
          if(id){
            setChangeCount(prev => prev + 1);
          }
        } else {
          message.error(res.message);
        }
      })
      .catch(e => {
        console.error(e);
        message.error('Something went wrong');
      });
  };

  const toggleMedia = (value, action) => {
    setRemoveItem((prevState) => ({
      ...prevState,
      [value]: !action,
    }));
  };
  

  return (
    <>
      <div className="layout-sign-up ">
        <Row justify="center">
            <Col span={18}>
                <Form
                name="basic"
                initialValues={{}}
                onFinish={submitForm}
                className="row-col"
                form={form}
                >
                <h2 className="sub-heading text-center">{data?.title ? 'Edit' : 'Add'} Lesson</h2>
                    <div>
                      {data?.image && <div className="form-poster text-center">
                        <div>
                          {!removeItem.poster &&  <img src={domain + data.image} alt="banner" className="form-poster" />}
                          <Button type="primary" className="text-capitalize mt-5" onClick={()=>toggleMedia('poster', removeItem.poster)}> {!removeItem.poster ? 'delete image' : 'revert to image'} </Button>
                        </div>
                       
                      </div>}
                    </div>
                    <Col span={24} className="input-div">
                        <InputIcon name='title' message='Title' type="string" />
                    </Col>
                    <Col span={24} className="input-div">
                        <CustomTextArea name='description' message='Description' />
                    </Col>
                    <Col span={24} className="input-div">
                        <CustomUploadImage name='image' message='upload banner for section' isRequired={false} />
                    </Col>
                    <Row justify="center">
                        <Col span={8} >
                            <FormButton value="Submit" htmlType="submit" />
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
         
      </div>
    </>
  );
}
